import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'

import styles from './ButtonShinyAnimated.module.scss'

interface ButtonShinyAnimatedProps {
  fullWidth?: boolean
  animated?: boolean
}

/**
 *
 * figma link: https://www.figma.com/design/szLufdGxU67ZrskZE8DAVA/Rebranded-Design-System?node-id=11-13874
 */
export const ButtonShinyAnimated: React.FC<PropsWithChildren<ButtonShinyAnimatedProps>> = (
  props
) => {
  const { children, fullWidth = false, animated = true } = props

  return (
    <div
      className={classNames(styles.animation, {
        [styles.fullWidth]: fullWidth,
        [styles.animated]: animated,
      })}
    >
      {children}
    </div>
  )
}
